import React from "react";
import "../Styles/ADCGridCentreLayout.css"; // Optional: extract styles here
import { FaPhone, FaMicrophoneSlash, FaPause, FaPhoneSlash } from "react-icons/fa";
import AdvertisementImage from "../../../../../assets/Advertisement/Swimming-advt.jpeg"


const UMGridCentreLayout = ( {recipientId} ) => {
  return (
    <div className="adc-centre-layout">

      <div className="adc-advertisement-container">
        <img src={AdvertisementImage} alt="Decorative" className="frame-image" />
      </div>

      {/* Ongoing Audio Call Section */}
      <div className="adc-audio-call-banner" >
        🔊 Ongoing Audio Call...
      </div>

      {/* Profile and Call Controls Section */}
      <div className="call-controls-container" style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        backgroundColor: "black",
        padding: 16,
        borderRadius: 12,
        boxShadow: "0 2px 6px rgba(0,0,0,0.1)"
      }}>
        
        {/* Profile Picture and Name */}
        <div className="profile-info" style={{ display: "flex", alignItems: "center" }}>
          <img
            src="../../../../../../assets/avatar/avatar-4.png"
            alt="Profile"
            style={{ width: 60, height: 60, borderRadius: "50%", marginRight: 12 }}
          />
          <div style={{ fontSize: 18, fontWeight: 600 }}>{recipientId}</div>
        </div>

        {/* Call Control Buttons */}
        <div className="control-buttons" style={{ display: "flex", gap: 12 }}>
          <button className="call-btn" style={{ ...btnStyle, backgroundColor: "rgb(34, 31, 31)", color: "white" }}><FaPhone /> Call</button>
          <button className="mute-btn" style={{ ...btnStyle, backgroundColor: "rgb(34, 31, 31)", color: "white" }}><FaMicrophoneSlash /> Mute</button>
          <button className="hold-btn" style={{ ...btnStyle, backgroundColor: "rgb(34, 31, 31)", color: "white" }}><FaPause /> Hold</button>
          <button className="cut-btn" style={{ ...btnStyle, backgroundColor: "rgb(34, 31, 31)", color: "white" }}><FaPhoneSlash /> End</button>
        </div>
      </div>
    </div>
  );
};

const btnStyle = {
  padding: "10px 16px",
  borderRadius: "8px",
  border: "none",
  backgroundColor: "#e0e0e0",
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  gap: 6,
  fontWeight: "bold"
};

export default UMGridCentreLayout;
